
/**
 * DeleteInspecaoPatrimonioUseCase
 */

import { IDeleteInspecaoPatrimonioUseCase } from "../../../presentation/useCases/delete/delete_inspecao_patrimonio_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class DeleteInspecaoPatrimonioUseCase implements IDeleteInspecaoPatrimonioUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async deleteInspecaoPatrimonio(idInspecaoPatrimonio: number): Promise<void> {
    await this.repository.deleteInspecaoPatrimonio(idInspecaoPatrimonio);
  }
}
